import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "top-tournaments-arrow_00a2b",
  "use": "top-tournaments-arrow_00a2b-usage",
  "viewBox": "0 0 13 7",
  "content": "<symbol viewBox=\"0 0 13 7\" id=\"top-tournaments-arrow_00a2b\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.264 0L13 .755 6.933 7 .867.755 1.598 0l5.335 5.487L12.264 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol